import { config } from './config';

const NEXT_API_BASE_URL = `${config.appUrl}/api`;
const API_BASE_URL = `${config.apiUrl}`;

export const getApiPathUrl = (path: string, token?: string): string => {
  return `${token ? API_BASE_URL : NEXT_API_BASE_URL}${path}`;
};
